<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <ProjectForm @submit-requested="submitRequested"></ProjectForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import ProjectForm from '@/views/Projects/ProjectForm.vue'

  export default {
  components: { ProjectForm },
  methods: {
    ...mapActions('projects', ['postProject']),
    submitRequested (input) {
      this.postProject(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 